export enum HostnameList {
  loc = "www.qubictron.loc",
  dev = "develop.qubictron.dev",
  release = "release.qubictron.dev",
  com = "www.qubictron.com",
}

// __LOCAL__ (set in vite.config.ts) routes calls at the local packer-3d
// backend (`pnpm dev` in ../packer-3d, port 8080) instead of prod.
// packer-3d's own route names differ from the prod gateway's, hence the
// separate *_PATH constants below.
export const API_BASE_URL = __LOCAL__ ? "http://localhost:8080" : "https://api.qubictron.com/load-calculator/v2";

export const STUFFING_PATH = __LOCAL__ ? "/stuffing" : "/pack";
export const PALLET_VALIDATION_PATH = __LOCAL__ ? "/validation" : "/pallet-validation";
export const getStuffingResultPath = (uuid: string) =>
  __LOCAL__ ? `/result/${uuid}` : `/stuffing/api-result?requestId=${uuid}`;
